<template>
  <div
    class="fixed flex justify-center items-center w-full h-full backdrop-blur-xs z-50"
  >
    <div class="text-2xl text-primary-600 font-bold">
      <slot>
        Getting your data <UiFaIcon :icon="['fas', 'spinner-scale']" :spin="true" />
      </slot>
    </div>
  </div>
</template>
